import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 64px;
  padding-bottom: 64px;
  background: #E5E5E5;


`;

export const Content = styled.div`
min-width: 580px;
height: fit-content;
display: flex;
flex-direction: column;
background: white;
padding: 24px 30px ;
  border: 1px solid rgba(230, 233, 236, 1);
gap: 35px;
`;

Content.Item = styled.div`

`

